/** Row labels shared by the discovery dialogs (seed discovery, Curate search). */

export function truncateAuthors(authors: string[]): string {
  if (!authors?.length) return "";
  const shown = authors.slice(0, 3).join(", ");
  return authors.length > 3 ? `${shown} et al.` : shown;
}

export function sourceLabel(sources?: string[]): string {
  const s = new Set(sources?.length ? sources : ["s2"]);
  if (s.has("s2") && s.has("openalex")) return "Semantic Scholar + OpenAlex";
  if (s.has("openalex")) return "OpenAlex";
  return "Semantic Scholar";
}
